import { SelectFilterListData } from 'features/common/types';

export interface CardStampQuickOption {
	id: string;
	label: string;
	apiValue: string;
}

export interface FeeQuickOption {
	id: string;
	label: string;
	values: number[];
}

export const CARD_STAMP_QUICK_OPTIONS: CardStampQuickOption[] = [
	{ id: 'visa', label: 'Visa', apiValue: 'visa' },
	{ id: 'mastercard', label: 'Mastercard', apiValue: 'master' },
	{ id: 'amex', label: 'Amex', apiValue: 'amex' },
	{ id: 'oca', label: 'OCA', apiValue: 'oca' },
];

export const CARD_STAMP_SELECT_OPTIONS: SelectFilterListData[] = CARD_STAMP_QUICK_OPTIONS.map((option) => ({
	id: option.apiValue,
	name: option.label,
}));

export const FEE_QUICK_OPTIONS: FeeQuickOption[] = [
	{ id: '1', label: '1', values: [1] },
	{ id: 'hasta-6', label: 'hasta 6', values: [1, 2, 3, 4, 5, 6] },
	{ id: 'hasta-10', label: 'hasta 10', values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
];

export const FEE_QUICK_ALL_ID = 'todas';

export const FEE_MULTISELECT_OPTIONS: SelectFilterListData[] = Array.from({ length: 12 }, (_, index) => {
	const fee = index + 1;
	return { id: fee, name: fee === 1 ? '1 cuota' : `${fee} cuotas` };
});
